import React, { PropsWithChildren } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ArrowLeft from '@mui/icons-material/ArrowBackIos';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, Tooltip } from '@mui/material';
import ActionButton from '@components/Button/ActionButton';
import If from '@components/If';
import Title from '@components/Title';
import downloadFileFromBlobResponse from '@core/utils/downloadFileFromBlobResponse';
import useGetStudiesStatisticsXLSX from '../../GetAll/hooks/useGetStudiesStatisticsXLSX';
import useFilters from '../../hooks/useFilters';
import Filters from '../Filters';
import useSx from './sx';

dayjs.extend(utc);

const createReportFileName = (start: string, end: string) => {
  const startDate = dayjs(start).format('DD-MM-YYYY');
  const endDate = dayjs(end).format('DD-MM-YYYY');
  return `Report_${startDate}_${endDate}`;
};

type Props = {
  title: string;
  onGoBack?: () => void;
  hideExport?: boolean;
};

const Layout = ({ children, title, onGoBack, hideExport = false }: PropsWithChildren<Props>) => {
  const sx = useSx();
  const [filters] = useFilters();
  const { getAllStudiesStatisticsXLSX, isLoading } = useGetStudiesStatisticsXLSX({
    start: dayjs(filters.start!).local().toDate(),
    end: dayjs(filters.end!).local().toDate(),
    sortOrder: 'asc',
  });

  const handleExport = async () => {
    const blobResponse = await getAllStudiesStatisticsXLSX();

    const reportTitle = createReportFileName(filters.start!, filters.end!);

    downloadFileFromBlobResponse(blobResponse, reportTitle, 'xlsx');
  };

  return (
    <Box sx={sx.root}>
      <Box className="Header-Root">
        <Box className="Title-Container">
          <If condition={!!onGoBack}>
            <Tooltip title="Atras">
              <ArrowLeft color="primary" className="Title-Icon" onClick={onGoBack} />
            </Tooltip>
          </If>
          <Title text={title} />
        </Box>
        <Filters />
        <If condition={!hideExport}>
          <ActionButton
            className="Export-Button"
            variant="contained"
            text="Exportar"
            onClick={handleExport}
            isLoading={isLoading}
            endIcon={<FileDownloadIcon />}
          />
        </If>
      </Box>
      {children}
    </Box>
  );
};

export default Layout;
